import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const playMsgFile = async (payload: { file: string }) => {
  const { file } = payload
  axios.post(`${getAPIService}/paging/play/messages/${file}`)
  return
}
